import { START_LOADING, END_LOADING } from "./loading_actions";
import { CATEGORIES_ADD_ROUTES } from "./categories_actions";
import { getListNews } from "../../utils/api";
import { getArrayForRoutes, changeDateFormat } from "../../utils/util_functions";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";


export const NEWS_REQUEST = 'NEWS_REQUEST';
export const NEWS_REQUEST_SUCCESS = 'NEWS_REQUEST_SUCCESS';
export const NEWS_REQUEST_FAILED = 'NEWS_REQUEST_FAILED';


export const getListNewsThunk = (type, page) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    getListNews(type, page)
      .then(news => {
        news.results = changeDateFormat(news.results);
        dispatch({ type: NEWS_REQUEST_SUCCESS, payload: news });
        dispatch({
          type: CATEGORIES_ADD_ROUTES,
          routes: getArrayForRoutes(news.results)
        });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({ type: NEWS_REQUEST_FAILED });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: error?.message
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
